import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonWorkOrderReportList } from "./Common/CommonWorkOrderReportList";

const WorkOrderReportPage = () => {
	return (
		<PageWrapper title='Ordens de Serviço'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-12'>
						<CommonWorkOrderReportList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default WorkOrderReportPage;